import { useContext } from 'react';
import { MPosContext } from 'utils/context';
import { getGroup } from 'utils/helpers';

const usePermissionHook = () => {
    const { permissions } = useContext(MPosContext);

    const getLobFromPermission = () => {
        if (permissions && permissions?.lob) {
            return permissions.lob;
        }
        return '';
    };

    const getPartnerIdFromPermission = () => {
        if (permissions) {
            return permissions.partner_id;
        }
        return '';
    };

    const getGroupNameFromPermission = (): string => {
        if (permissions) {
            return getGroup(permissions.group, permissions.partner_id);
        }
        return '';
    };

    const getIsSubDealer = (): boolean => {
        return getGroupNameFromPermission().toLowerCase() === 'sub_dealer';
    };

    return {
        getLobFromPermission,
        getPartnerIdFromPermission,
        getGroupNameFromPermission,
        getIsSubDealer,
    };
};

export default usePermissionHook;
